import { render, staticRenderFns } from "./ProductDetailsCard.vue?vue&type=template&id=7edbfea4&"
import script from "./ProductDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports